import { SettingsValue } from "types/payments";

/**
 * A plan created by accepting a settlement offer is fixed: the customer may
 * only swap the payment method on it. Update plan and Cancel plan must stay
 * hidden wherever a plan's actions menu is rendered.
 */
export const isSettlementOriginPlan = (plan: {
  settlement_offer?: string | null;
  plan_id?: number;
  offer_type?: string | null;
}): boolean =>
  plan?.plan_id && plan?.plan_id > 0
    ? plan?.settlement_offer === SettingsValue.YES
    : plan?.offer_type
      ? plan?.offer_type !== ""
      : false;
